import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Clock } from "lucide-react";
import { pubApi, kwh, n } from "@/components/cliente/clienteApi";
import { SkyScene } from "@/components/cliente/SkyScene";
import { DayChart, Card } from "@/components/cliente/ClienteCharts";
import { BrandBar } from "@/components/cliente/BrandBar";
import { Vita } from "@/components/cliente/ClienteView";

const FONT = `@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&display=swap');.cliente-font{font-family:'Nunito',sans-serif}`;

// Vetrina pubblica in sola lettura (24 ore), senza dati personali
export default function CondivisoPage() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { pubApi.get(`/condiviso/${token}`).then((r) => setD(r.data)).catch((e) => setErr(e.response?.data?.detail || "Link non disponibile")); }, [token]);
  return (
    <div className="cliente-font min-h-[100dvh] bg-slate-50 text-slate-800" data-testid="condiviso-page">
      <style>{FONT}</style>
      <div className="mx-auto max-w-2xl space-y-4 p-4 pb-10">
        {err ? <p className="py-24 text-center text-slate-500" data-testid="condiviso-error">{err}</p> : !d ? <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-sky-500" /></div> : <>
          <BrandBar logo={d.installatore?.logo} nome={d.installatore?.nome} />
          <div>
            <h1 className="text-2xl font-extrabold text-slate-900" data-testid="condiviso-titolo">{d.titolo}</h1>
            <p className="text-sm text-slate-500">{[d.kwp && `${n(d.kwp, 1)} kWp di energia pulita`, d.comune].filter(Boolean).join(" · ")}</p>
          </div>
          <SkyScene imp={d} />
          <Card title={`La produzione di oggi · ${kwh(d.oggi_kwh)}`} testid="condiviso-grafico">
            {d.punti.length ? <DayChart pts={d.punti} cons={false} /> : <p className="text-sm text-slate-500">Il grafico di oggi sarà disponibile appena sorge il sole.</p>}
          </Card>
          <Vita v={d.vita} />
          <a href="https://torri.solar" target="_blank" rel="noreferrer" className="block rounded-3xl bg-white p-4 text-center text-sm text-slate-600 shadow-sm ring-1 ring-slate-100" data-testid="condiviso-firma">
            Realizzato da <b className="text-slate-800">{d.installatore?.nome}</b> in collaborazione con <b className="text-amber-600">TORRI</b> · scopri di più su torri.solar</a>
          <p className="flex items-center justify-center gap-1.5 text-xs text-slate-400" data-testid="condiviso-scadenza">
            <Clock className="h-3.5 w-3.5" />Link visibile fino al {new Date(d.scade).toLocaleString("it-IT", { day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" })}</p>
        </>}
      </div>
    </div>
  );
}
